// extracted by mini-css-extract-plugin
module.exports = {"PageUserActivities":"PageUserActivities___2vFlc"};